import { OfferYMapFlatPlacemarkProps } from '../flat/FlatPlacemarkProps';
import { OfferYMapFlatMultiProps } from '../flat/FlatMultiProps';
import { OfferYMapRoomPlacemarkProps } from '../room/RoomPlacemarkProps';
import { OfferYMapRoomMultiProps } from '../room/RoomMultiProps';

import { OfferYMapLandPlacemarkProps } from '../land/LandPlacemarkProps';
import { OfferYMapHousePlacemarkProps } from '../house/HousePlacemarkProps';
import { OfferYMapHouseMultiProps } from '../house/HouseMultiProps';
import { OfferYMapLandMultiProps } from '../land/LandMultiProps';

export type OfferYMapUnionPlacemarkItem = OfferYMapFlatPlacemarkProps
    | OfferYMapFlatMultiProps
    | OfferYMapHouseMultiProps
    | OfferYMapLandMultiProps
    | OfferYMapRoomPlacemarkProps
    | OfferYMapRoomMultiProps
    | OfferYMapLandPlacemarkProps
    | OfferYMapHousePlacemarkProps
    | {
        geohash: string;
        coordinates: {
            latitude: number;
            longitude: number;
        };
        kind: 'tagless';
    };

type OfferYMapUnionPlacemarkItemMulti = OfferYMapFlatMultiProps
    | OfferYMapRoomMultiProps
    | OfferYMapHouseMultiProps
    | OfferYMapLandMultiProps;

export function offerYMapUnionPlacemarkIsMulti(
    item: OfferYMapUnionPlacemarkItem
): item is OfferYMapUnionPlacemarkItemMulti {
    switch (item.kind) {
        case 'flatMulti':
        case 'roomMulti':
        case 'houseMulti':
        case 'landMulti': return true;
        default: return false;
    }
}
